import { createSlice } from "@reduxjs/toolkit";
import {
  getChangeRequestList,
  getClientsEvents,
  getEventDetail,
  getEventReqSongs,
  getEvents,
  getEventSongs,
  getMusician,
  getNewUsers,
  getSongReqSongs,
  updateSongRequest,
  updateIsContacted,
} from "../Actions/event";
import { toast } from "react-toastify";

const initialState = {
  loading: false,
  eventsList: [],
  eventDetail: [],
  requestedSongs: [],
  eventSongs: {},
  clientEventsList: [],
  visibleRange: null,
  newUserLists: [],
  MusiciansList: [],
  newRequestedSongs: [],
  getChangeRequestList: [],
};

const EventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    setVisibleRange(state, action) {
      state.visibleRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEvents.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.eventsList = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });

    // ========================================================================

    builder.addCase(getEventDetail.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.eventDetail = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });
    // =========================================================================
    builder.addCase(getEventReqSongs.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.requestedSongs = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });

    // song requested =========================================================================
    builder.addCase(getSongReqSongs.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.newRequestedSongs = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });
    // =========================================================================
    builder.addCase(getEventSongs.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.eventSongs = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });

    // =========================================================================

    builder.addCase(getClientsEvents.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.clientEventsList = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });

    // =========================================================================

    builder.addCase(getNewUsers.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.newUserLists = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });
    builder.addCase(updateSongRequest.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.loading = false;
        toast.success(payload?.message);
      } else {
        toast.error(payload?.message);
        state.loading = false;
      }
    });
    builder.addCase(updateSongRequest.rejected, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.loading = false;
        toast.success(payload?.message);
      } else {
        toast.error(payload?.message);
        state.loading = false;
      }
    });
    builder.addCase(getMusician.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.loading = false;
        // toast.success(payload?.message)
        state.MusiciansList = payload.data;
      } else {
        toast.error(payload?.message);
        state.loading = false;
      }
    });
    builder.addCase(getMusician.rejected, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.loading = false;
        // toast.success(payload?.message)
      } else {
        // toast.error(payload?.message)
        state.loading = false;
      }
    });

    // ============================================================================== change request by user

    builder.addCase(getChangeRequestList.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.getChangeRequestList = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });

    // ==============================================================================
    builder
      .addCase(updateIsContacted.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateIsContacted.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.statusCode === 200) {
          state.isContacted = true;
        } else {
          state.error = payload?.message || "Failed to update contact status";
        }
      })
      .addCase(updateIsContacted.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Something went wrong";
      });
  },
});

export const { setVisibleRange } = EventSlice.actions;
export default EventSlice.reducer;
